// common/hooks/useCartModals.ts
import { useDispatch, useSelector } from "react-redux";
import {
  openCartModal,
  closeCartModal,
  openComplexOrderCartModal,
  closeComplexOrderCartModal,
  selectIsCartModalOpen,
  selectIsComplexOrderCartModalOpen,
} from "../../store/slices/commonModalSlice";

export const useCartModals = () => {
  const dispatch = useDispatch();
  const isCartOpen = useSelector(selectIsCartModalOpen);
  const isComplexCartOpen = useSelector(selectIsComplexOrderCartModalOpen);

  return {
    isCartOpen,
    isComplexCartOpen,
    openCart: () => dispatch(openCartModal()),
    closeCart: () => dispatch(closeCartModal()),
    openComplexCart: () => dispatch(openComplexOrderCartModal()),
    closeComplexCart: () => dispatch(closeComplexOrderCartModal()),
  };
};
